const clickOriginalLinkCommand = (popup, editor, cmd, param) => {
  const selector = param
    ? `.teo-link-original-buttons .fr-command[data-cmd="${cmd}"][data-param1="${param}"]`
    : `.teo-link-original-buttons .fr-command[data-cmd="${cmd}"]`;

  const original = popup.querySelector(selector);

  if (original) {
    original.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    original.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );
    return true;
  }

  editor.selection?.restore?.();

  if (param !== undefined) {
    editor.commands.exec(cmd, param);
  } else {
    editor.commands.exec(cmd);
  }

  return true;
};

const getActiveLinkEl = (editor) => {
  const linkFromApi = editor?.link?.get?.()?.get?.(0);
  if (linkFromApi) return linkFromApi;

  const selectionEl = editor?.selection?.element?.();
  return selectionEl?.closest?.('a') || null;
};

const updateLinkSubmenuActiveState = (editor, popup) => {
  const link = getActiveLinkEl(editor);
  if (!link) return;

  popup.querySelectorAll('[data-teo-link-param]').forEach((btn) => {
    const cmd = btn.getAttribute('data-teo-link-cmd');
    const param = btn.getAttribute('data-teo-link-param');

    btn.classList.remove('teo-link-settings-item_active');
    btn.querySelector('.teo-active-check')?.remove();

    const isActive = cmd === 'linkStyle' && link.classList.contains(param);

    if (isActive) {
      btn.classList.add('teo-link-settings-item_active');
      btn.insertAdjacentHTML(
        'beforeend',
        `<span class="teo-active-check ml-auto">
          <i class="far fa-check text-[17px]"></i>
        </span>`
      );
    }
  });
};

const positionPopupAtTargetTopLeft = (popup, target) => {
  if (!popup || !target) return;

  const rect = target.getBoundingClientRect();

  popup.style.setProperty('position', 'absolute', 'important');
  popup.style.setProperty(
    'left',
    `${rect.left + window.scrollX}px`,
    'important'
  );
  popup.style.setProperty('top', `${rect.top + window.scrollY}px`, 'important');
  popup.style.setProperty('transform', 'none', 'important');
};

export const updateLinkPopupDesign = (editor) => {
  const t = window.i18n.t;

  const linkMenuItems = [
    {
      label: t('widgets.toolbar_button.link_settings.open_link'),
      icon: '<i class="far fa-external-link-alt text-[17px]"></i>',
      cmd: 'linkOpen',
    },
    {
      label: t('widgets.toolbar_button.link_settings.link_styling'),
      icon: '<img src="/images/icons/color-wand.svg" class="!w-5" />',
      cmd: 'linkStyle',
      arrow: true,
    },
    {
      label: t('widgets.toolbar_button.link_settings.edit_link'),
      icon: '<i class="far fa-pencil text-[17px]"></i>',
      cmd: 'linkEdit',
    },
    {
      label: t('widgets.toolbar_button.link_settings.remove_link'),
      icon: '<img src="/images/icons/trash_icon_red.svg" class="!w-4" />',
      cmd: 'linkRemove',
      danger: true,
    },
  ];

  const submenus = {
    linkStyle: [
      {
        label: t('widgets.toolbar_button.link_settings.green'),
        icon: '',
        param: 'fr-green',
      },
      {
        label: t('widgets.toolbar_button.link_settings.thick'),
        icon: '',
        param: 'fr-strong',
      },
    ],
  };

  const popup = editor?.popups?.get?.('link.edit')?.get?.(0);
  if (!popup || popup.dataset.teoLinkPopupReady === 'true') return;

  popup.dataset.teoLinkPopupReady = 'true';
  popup.classList.add('teo-link-popup');

  const link = editor?.link?.get?.()?.get?.(0);
  if (link) {
    positionPopupAtTargetTopLeft(popup, link);
  }

  const buttons = popup.querySelector('.fr-buttons');
  if (!buttons) return;

  const oldButtonsHtml = buttons.innerHTML;

  buttons.innerHTML = `
    <div class="teo-link-settings-menu">
      ${linkMenuItems
        .map((item) => {
          const submenu = submenus[item.cmd];

          return `
            <div class="teo-link-settings-row">
              <button
                type="button"
                class="teo-link-settings-item ${
                  item.danger ? 'teo-link-settings-item_danger' : ''
                }"
                data-teo-link-cmd="${item.cmd}"
              >
                <span class="teo-link-settings-icon">${item.icon}</span>
                <span class="teo-link-settings-label">${item.label}</span>
                ${
                  item.arrow
                    ? '<i class="far fa-chevron-right text-grey-03 ml-auto"></i>'
                    : ''
                }
              </button>

              ${
                submenu
                  ? `
                    <div class="teo-link-submenu-inline">
                      <div class="teo-link-submenu-list">
                        ${submenu
                          .map(
                            (sub) => `
                              <button
                                type="button"
                                class="teo-link-settings-item"
                                data-teo-link-cmd="${item.cmd}"
                                data-teo-link-param="${sub.param}"
                              >
                                <span class="teo-link-submenu-icon">${sub.icon}</span>
                                <span class="teo-link-submenu-label">${sub.label}</span>
                              </button>
                            `
                          )
                          .join('')}
                      </div>
                    </div>
                  `
                  : ''
              }
            </div>
          `;
        })
        .join('')}
    </div>

    <div class="teo-link-original-buttons" style="display:none;">
      ${oldButtonsHtml}
    </div>
  `;

  setTimeout(() => {
    updateLinkSubmenuActiveState(editor, popup);
  }, 0);

  popup.querySelectorAll('[data-teo-link-cmd]').forEach((btn) => {
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const cmd = btn.getAttribute('data-teo-link-cmd');
      const param = btn.getAttribute('data-teo-link-param');

      if (!cmd) return;
      if (submenus[cmd] && !param) return;

      clickOriginalLinkCommand(popup, editor, cmd, param || undefined);

      setTimeout(() => {
        updateLinkSubmenuActiveState(editor, popup);

        if (cmd !== 'linkStyle') {
          editor.popups.hide('link.edit');
        }
      }, 0);
    });
  });
};
